var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseBody",
    [
      _c(
        "BaseTopBar",
        [
          _c("BaseTopBarContent", { attrs: { className: "col-4 left" } }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("sidebar.payslip")) +
                " > " +
                _vm._s(_vm.payslip.prlCode) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("BaseTopBarContent", { attrs: { className: "right" } }, [
            !_vm.loading
              ? _c(
                  "div",
                  { staticClass: "action" },
                  [
                    _vm.showOptionButton
                      ? _c("BaseActionDropdown", {
                          attrs: {
                            icon: "fas fa-cog",
                            text: _vm.$t("button.options"),
                            items: _vm.options
                          },
                          on: { onSelect: _vm.handleSelectOption }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("BaseAction", {
                      attrs: {
                        icon: "fas fa-copy",
                        iconClassName: "",
                        text: _vm.$t("button.clone"),
                        textClassName: ""
                      },
                      on: { onClick: _vm.openCloneModal }
                    }),
                    _vm._v(" "),
                    _vm.hasRoleApprove
                      ? _c("BaseActionUpdateStatus", {
                          attrs: {
                            docType: "prl",
                            processStatus: _vm.payslip.process.status,
                            loading: _vm.loadingUpdateStatus
                          },
                          on: { onSelect: _vm.handleSelectStatus }
                        })
                      : _c(
                          "div",
                          { staticClass: "dropdown nodro item" },
                          [
                            _c("BaseDocumentProcessStatus", {
                              attrs: {
                                docType: "prl",
                                status: _vm.payslip.process.status
                              }
                            })
                          ],
                          1
                        )
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "BaseContent",
        { attrs: { loading: _vm.loading } },
        [
          _c("WrapperDoc", {
            scopedSlots: _vm._u([
              {
                key: "form",
                fn: function() {
                  return [
                    _c("PayrollPaySlipForm", {
                      attrs: {
                        state: _vm.payslip,
                        prlCode: _vm.payslip.prlCode,
                        groups: _vm.groups,
                        conditions: _vm.conditions,
                        employees: _vm.employees,
                        isSubmitted: _vm.isSubmitted,
                        edit: true,
                        disabled: _vm.disabledForm,
                        form: _vm.form,
                        showActionButtons: !_vm.disabledForm
                      },
                      on: {
                        "update:form": function($event) {
                          _vm.form = $event
                        },
                        onSubmit: _vm.handleSubmit
                      }
                    })
                  ]
                },
                proxy: true
              },
              {
                key: "ref",
                fn: function() {
                  return [
                    _c(
                      "DocRef",
                      {
                        attrs: {
                          refDoc: "prl",
                          refId: _vm.payslip.prlId,
                          refCode: _vm.payslip.prlCode,
                          showLog: _vm.getPayrollSetting.log_topic.is_active,
                          showAttachFile:
                            _vm.getPayrollSetting.attach_file.is_active,
                          logTopics: _vm.getPayrollSetting.log_topic.options,
                          isSubmitted: _vm.isSubmitted
                        }
                      },
                      [
                        _c("RefPRL", {
                          attrs: {
                            payslip: _vm.payslip,
                            disabled: !_vm.hasRoleCreate
                          }
                        })
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("baseConfirmDeleteModal", {
            attrs: { show: _vm.modal.show, loading: _vm.modal.loading },
            on: {
              onClose: _vm.handleCloseModal,
              onCancel: _vm.handleCancleModal,
              onSubmit: _vm.handleSumitModal
            }
          }),
          _vm._v(" "),
          _c("BaseConfirmDiscardModal", {
            attrs: { show: _vm.confirmDiscardModal.show },
            on: {
              onCancel: _vm.handleDiscardCancleModal,
              onConfirm: _vm.handleDiscardConfirmModal
            }
          }),
          _vm._v(" "),
          _c("BaseConfirmCloneModal", {
            attrs: {
              show: _vm.modalConfirmClone.show,
              loading: _vm.modalConfirmClone.loading
            },
            on: {
              onClose: _vm.handleCloseCloneModal,
              onCancel: _vm.handleCancleCloneModal,
              onConfirm: function($event) {
                return _vm.handleConfirmCloneModal({
                  payload: _vm.payloadClone,
                  createApiFn: _vm.createPaySlip,
                  redirectTo: "PaySlipList",
                  refCode: "prl_code"
                })
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dc7ff390", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc7ff390","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/payroll/payslip/Edit.vue
// module id = null
// module chunks = 